function usesKitabooExclusionPagination() {
  const grid = document.getElementById('product-grid');
  return !!(grid && grid.dataset.exclusionPagination === 'true');
}

function usesKitabooPublisherCollection() {
  const grid = document.getElementById('product-grid');
  return !!(grid && grid.dataset.publisherCollection === 'true');
}

function isLargeCollectionFacets() {
  const wrapper = document.getElementById('FacetsWrapperDesktop');
  const mobileForm = document.getElementById('FacetFiltersFormMobile');
  return !!(
    (wrapper && wrapper.dataset.largeCollection === 'true') ||
    (mobileForm && mobileForm.dataset.largeCollection === 'true')
  );
}

function isJsSidebarFiltersPage() {
  const wrapper = document.getElementById('FacetsWrapperDesktop');
  const mobileForm = document.getElementById('FacetFiltersFormMobile');
  return !!(
    (wrapper && wrapper.dataset.jsSidebarFilters === 'true') ||
    (mobileForm && mobileForm.dataset.jsSidebarFilters === 'true')
  );
}

function shouldReloadCollectionOnFacetChange() {
  if (isLargeCollectionFacets()) return false;
  if (usesKitabooPublisherCollection()) return true;
  if (usesKitabooExclusionPagination()) return true;
  return false;
}

function usesNativeFacetReload() {
  return usesKitabooExclusionPagination() && !isLargeCollectionFacets();
}

function navigateWithFacetParams(searchParams) {
  const query = normalizeCollectionSearchParams(sanitizeSearchParams(searchParams || ''));
  window.location.assign(window.location.pathname + (query ? '?' + query : ''));
}

function refreshExclusionCollectionFacetUi(searchParams) {
  const grid = document.getElementById('product-grid');
  if (!grid || !grid.dataset.id) return Promise.resolve();
  const mergedParams = normalizeCollectionSearchParams(searchParams || '');
  const url = `${window.location.pathname}?section_id=${grid.dataset.id}&${mergedParams}`;
  return fetch(url)
    .then((response) => response.text())
    .then((html) => {
      FacetFiltersForm.renderFilters(html, null);
      FacetFiltersForm.renderActiveFacets(html);
      FacetFiltersForm.renderAdditionalElements(html);
    })
    .catch(() => {});
}

function applyStandardExclusionFacetChange(mergedParams, collectionEl, countContainer, countContainerDesktop) {
  const hasFilters = mergedParams && mergedParams.indexOf('filter.') !== -1;
  const grid = document.getElementById('product-grid');

  if (collectionEl) collectionEl.classList.add('loading');
  if (countContainer) countContainer.classList.add('loading');
  if (countContainerDesktop) countContainerDesktop.classList.add('loading');

  if (!window.KitabooExclusionPagination) {
    navigateWithFacetParams(mergedParams);
    return;
  }

  if (hasFilters) {
    if (grid) grid.dataset.kitabooHydrated = 'filtered';
    Promise.resolve(window.KitabooExclusionPagination.applyFacetFilters())
      .then(() => refreshExclusionCollectionFacetUi(mergedParams))
      .finally(() => {
        clearKitabooCollectionLoading();
      });
    return;
  }

  if (grid) delete grid.dataset.kitabooHydrated;
  finishKitabooExclusionRefresh(refreshKitabooExclusionView());
  refreshExclusionCollectionFacetUi(mergedParams).finally(() => {
    clearKitabooCollectionLoading();
  });
}

function updateAllProductCountElements(countHtml) {
  if (!countHtml) return;
  document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((el) => {
    el.innerHTML = countHtml;
    el.classList.remove('loading');
    el.dataset.countReady = 'true';
  });
}

function revealInitialCollectionCount() {
  document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((el) => {
    if (!el || el.dataset.countReady === 'true') return;
    const text = String(el.textContent || '').trim();
    if (text && /\d/.test(text)) {
      el.dataset.countReady = 'true';
      el.classList.remove('loading');
    }
  });
}

function normalizeCollectionSearchParams(searchParams) {
  const params = new URLSearchParams(sanitizeSearchParams(searchParams || ''));
  if (!usesKitabooPublisherCollection()) {
    if (params.get('view') === 'publisher') {
      params.delete('view');
    }
    if (params.has('filter.p.vendor') && !String(params.get('filter.p.vendor') || '').trim()) {
      params.delete('filter.p.vendor');
    }
  }
  return sanitizeSearchParams(params.toString());
}

function getCleanedDefaultCollectionUrl() {
  const grid = document.getElementById('product-grid');
  if (grid && grid.dataset.publisherCollection === 'true') return null;

  const params = new URLSearchParams(window.location.search);
  let changed = false;

  if (!usesKitabooPublisherCollection() && params.get('view') === 'publisher') {
    params.delete('view');
    changed = true;
  }

  if (params.has('filter.p.vendor') && !String(params.get('filter.p.vendor') || '').trim()) {
    params.delete('filter.p.vendor');
    changed = true;
  }

  [...new Set(params.keys())].forEach((key) => {
    if (key.indexOf('filter.') !== 0) return;
    const values = params.getAll(key).filter((value) => String(value || '').trim());
    if (values.length === params.getAll(key).length) return;
    params.delete(key);
    values.forEach((value) => params.append(key, value));
    changed = true;
  });

  if (!changed) return null;

  params.delete('page');
  const query = sanitizeSearchParams(params.toString());
  return window.location.pathname + (query ? '?' + query : '');
}

function redirectIfInvalidCollectionUrlParams() {
  const cleanUrl = getCleanedDefaultCollectionUrl();
  if (!cleanUrl) return false;
  const currentUrl = window.location.pathname + window.location.search;
  if (cleanUrl === currentUrl) return false;
  window.location.replace(cleanUrl);
  return true;
}

window.__redirectIfInvalidCollectionUrlParams = redirectIfInvalidCollectionUrlParams;

document.addEventListener('DOMContentLoaded', function () {
  redirectIfInvalidCollectionUrlParams();
  revealInitialCollectionCount();
  syncActiveFacetPills();
});

document.addEventListener('lc-filters:rendered', function () {
  syncActiveFacetPills();
});

function clearKitabooCollectionLoading() {
  const gridContainer = document.getElementById('ProductGridContainer');
  const collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
  if (collectionEl) collectionEl.classList.remove('loading');
  ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('loading');
  });
}

function refreshKitabooExclusionView() {
  if (!usesKitabooExclusionPagination() || !window.KitabooExclusionPagination) return null;
  const refresh = window.KitabooExclusionPagination.refreshCollectionView;
  if (typeof refresh !== 'function') return null;
  return refresh();
}

function finishKitabooExclusionRefresh(refreshResult) {
  Promise.resolve(refreshResult).finally(() => {
    clearKitabooCollectionLoading();
  });
}

const SINGLE_VALUE_SEARCH_KEYS = new Set(['sort_by', 'view', 'q', 'page', 'section_id', 'options[prefix]']);

function appendAllSearchParams(target, source) {
  [...new Set(source.keys())].forEach((key) => {
    source.getAll(key).forEach((value) => {
      target.append(key, value);
    });
  });
}

function sanitizeSearchParams(paramString) {
  const raw = new URLSearchParams(paramString || '');
  const sanitized = new URLSearchParams();

  [...new Set(raw.keys())].forEach((key) => {
    const values = raw.getAll(key).filter((value) => {
      if (key.indexOf('filter.') === 0 && !value) return false;
      return true;
    });
    if (values.length === 0) return;

    if (SINGLE_VALUE_SEARCH_KEYS.has(key)) {
      sanitized.set(key, values[values.length - 1]);
      return;
    }

    values.forEach((value) => {
      sanitized.append(key, value);
    });
  });

  sanitized.delete('page');
  return sanitized.toString();
}

function mergeLocationSearchParams(formParamString) {
  const merged = new URLSearchParams(formParamString || '');
  const current = new URLSearchParams(window.location.search);

  current.forEach((value, key) => {
    if (key === 'page') return;
    if (merged.has(key)) return;
    if (key === 'view' || key === 'q' || key.indexOf('filter.') === 0) {
      merged.append(key, value);
    }
  });

  merged.delete('page');
  return sanitizeSearchParams(merged.toString());
}

function mergeFacetFormParams(formParamString) {
  const merged = new URLSearchParams(formParamString || '');
  const current = new URLSearchParams(window.location.search);

  if (!merged.has('sort_by') && current.has('sort_by')) {
    merged.set('sort_by', current.get('sort_by'));
  }
  if (!merged.has('view') && current.has('view')) {
    const view = current.get('view');
    if (usesKitabooPublisherCollection() || view !== 'publisher') {
      merged.set('view', view);
    }
  }
  if (!merged.has('q') && current.has('q')) {
    merged.set('q', current.get('q'));
  }
  if (!merged.has('options[prefix]') && current.has('options[prefix]')) {
    merged.set('options[prefix]', current.get('options[prefix]'));
  }

  merged.delete('page');
  return sanitizeSearchParams(merged.toString());
}

function parseFacetRemoveParams(href) {
  const queryIndex = String(href || '').indexOf('?');
  const fromHref = queryIndex === -1 ? '' : href.slice(queryIndex + 1);
  const params = new URLSearchParams(sanitizeSearchParams(fromHref));
  const current = new URLSearchParams(window.location.search);
  const isClearAll = !fromHref || fromHref.indexOf('filter.') === -1;

  if (isClearAll) {
    if (!params.has('sort_by') && current.has('sort_by')) {
      params.set('sort_by', current.get('sort_by'));
    }
    if (!params.has('view') && current.has('view')) {
      params.set('view', current.get('view'));
    }
  }

  return sanitizeSearchParams(params.toString());
}

function resetFacetFormInputs() {
  document.querySelectorAll('[data-lc-filter]').forEach((input) => {
    if (input.type === 'checkbox') {
      input.checked = false;
    } else if (input.type === 'number') {
      input.value = '';
    }
  });

  document.querySelectorAll(
    '#FacetFiltersForm input[type="checkbox"][name^="filter."], #FacetFiltersFormMobile input[type="checkbox"][name^="filter."]'
  ).forEach((input) => {
    input.checked = false;
  });

  document.querySelectorAll(
    '#FacetFiltersForm input[name^="filter.v."], #FacetFiltersFormMobile input[name^="filter.v."]'
  ).forEach((input) => {
    input.value = '';
  });
}

const FACET_CLOSE_ICON_HTML =
  '<svg aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const FACET_PARAM_LABELS = {
  'filter.p.product_type': 'Category',
  'filter.p.vendor': 'Publisher',
  'filter.p.m.custom.combined_product_tags': 'Sub Category',
  'filter.p.m.custom.author': 'Author',
  'filter.p.m.custom.book_type': 'Book Type',
  'filter.v.price': 'Price'
};

function escapeFacetText(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function stripFacetCountSuffix(text) {
  return String(text || '').replace(/\s*\(\d+\+?\)\s*$/, '').trim();
}

function hasFilterParamsInUrl() {
  const params = new URLSearchParams(window.location.search);
  let found = false;
  params.forEach((value, key) => {
    if (key.indexOf('filter.') === 0 && value) found = true;
  });
  return found;
}

function buildClearAllFilterUrl() {
  if (isJsSidebarFiltersPage()) {
    return window.location.pathname;
  }

  const params = new URLSearchParams(window.location.search);
  const keep = new URLSearchParams();
  if (params.has('sort_by')) keep.set('sort_by', params.get('sort_by'));
  if (usesKitabooPublisherCollection() && params.has('view')) {
    keep.set('view', params.get('view'));
  }
  if (params.has('q')) keep.set('q', params.get('q'));
  if (params.has('options[prefix]')) keep.set('options[prefix]', params.get('options[prefix]'));
  const query = sanitizeSearchParams(keep.toString());
  return window.location.pathname + (query ? '?' + query : '');
}

function buildRemoveFilterUrl(paramName, paramValue) {
  const params = new URLSearchParams(window.location.search);
  const values = params.getAll(paramName);
  params.delete(paramName);
  values.forEach((value) => {
    if (value !== paramValue) params.append(paramName, value);
  });
  params.delete('page');
  return window.location.pathname + (params.toString() ? '?' + sanitizeSearchParams(params.toString()) : '');
}

function buildRemovePriceFilterUrl() {
  const params = new URLSearchParams(window.location.search);
  params.delete('filter.v.price.gte');
  params.delete('filter.v.price.lte');
  params.delete('page');
  return window.location.pathname + (params.toString() ? '?' + sanitizeSearchParams(params.toString()) : '');
}

function resolveFacetInputLabel(paramName, paramValue) {
  const inputs = document.querySelectorAll(
    'input[name="' + paramName.replace(/"/g, '\\"') + '"]'
  );
  for (let i = 0; i < inputs.length; i += 1) {
    const input = inputs[i];
    if (String(input.value) !== String(paramValue)) continue;
    const label = input.closest('label');
    const textEl = label && label.querySelector('span[aria-hidden="true"]');
    if (textEl) return stripFacetCountSuffix(textEl.textContent);
  }
  return paramValue;
}

function resolveFacetGroupLabel(paramName, paramValue) {
  const inputs = document.querySelectorAll(
    'input[name="' + paramName.replace(/"/g, '\\"') + '"]'
  );
  for (let i = 0; i < inputs.length; i += 1) {
    const input = inputs[i];
    if (paramValue != null && String(input.value) !== String(paramValue)) continue;
    const details = input.closest('details');
    const summary = details && details.querySelector('summary span');
    if (summary) return stripFacetCountSuffix(summary.textContent);
  }
  return FACET_PARAM_LABELS[paramName] || 'Filter';
}

function formatPriceFacetLabel() {
  const params = new URLSearchParams(window.location.search);
  const min = params.get('filter.v.price.gte');
  const max = params.get('filter.v.price.lte');
  if (!min && !max) return '';
  const minLabel = min || '0';
  const maxLabel = max || 'max';
  return minLabel + '-' + maxLabel;
}

function collectActiveFiltersForPills() {
  const params = new URLSearchParams(window.location.search);
  const filters = [];

  params.forEach((value, key) => {
    if (!value || key.indexOf('filter.') !== 0) return;
    if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') return;
    filters.push({
      paramName: key,
      value: value,
      groupLabel: resolveFacetGroupLabel(key, value),
      valueLabel: resolveFacetInputLabel(key, value),
      removeUrl: buildRemoveFilterUrl(key, value)
    });
  });

  const priceLabel = formatPriceFacetLabel();
  if (priceLabel) {
    filters.push({
      paramName: 'filter.v.price',
      value: priceLabel,
      groupLabel: FACET_PARAM_LABELS['filter.v.price'],
      valueLabel: priceLabel,
      removeUrl: buildRemovePriceFilterUrl()
    });
  }

  return filters;
}

function buildFacetPillHtml(filter) {
  const label = filter.groupLabel + ': ' + filter.valueLabel;
  return (
    '<facet-remove>' +
      '<a href="' + escapeFacetText(filter.removeUrl) + '" class="active-facets__button active-facets__button--light">' +
        '<span class="active-facets__button-inner button button--tertiary">' +
          '<span class="active-facets__button-label">' + escapeFacetText(label) + '</span>' +
          FACET_CLOSE_ICON_HTML +
          '<span class="visually-hidden">Remove filter</span>' +
        '</span>' +
      '</a>' +
    '</facet-remove>'
  );
}

function syncActiveFacetPills() {
  const containers = document.querySelectorAll('.active-facets-desktop, .active-facets-mobile');
  if (!containers.length) return;

  if (!hasFilterParamsInUrl()) {
    containers.forEach((container) => {
      container.removeAttribute('data-has-active-filters');
      container.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)').forEach((pill) => {
        pill.remove();
      });
    });
    return;
  }

  const activeFilters = collectActiveFiltersForPills();
  if (!activeFilters.length) return;

  const clearAllUrl = buildClearAllFilterUrl();
  const pillsHtml = activeFilters.map(buildFacetPillHtml).join('');

  containers.forEach((container) => {
    container.dataset.hasActiveFilters = 'true';

    const removeAllLink = container.querySelector('a.active-facets__button-remove');
    if (removeAllLink) {
      removeAllLink.href = clearAllUrl;
      const removeAllWrapper = removeAllLink.closest('facet-remove');
      if (removeAllWrapper) removeAllWrapper.style.display = '';
    }

    container.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)').forEach((pill) => {
      pill.remove();
    });

    const verticalFilter = container.querySelector('.active-facets-vertical-filter');
    if (verticalFilter) {
      verticalFilter.insertAdjacentHTML('afterend', pillsHtml);
      return;
    }

    const wrapper = container.querySelector('facet-remove.active-facets__button-wrapper');
    if (wrapper) {
      wrapper.insertAdjacentHTML('beforebegin', pillsHtml);
      return;
    }

    container.insertAdjacentHTML('beforeend', pillsHtml);
  });
}

window.__syncActiveFacetPills = syncActiveFacetPills;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target && event.target.dataset && event.target.dataset.lcFilter) return;
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      if (shouldReloadCollectionOnFacetChange()) {
        window.location.reload();
        return;
      }
      const w = document.getElementById('FacetsWrapperDesktop');
      if (w && w.dataset.largeCollection === 'true') return;
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, mergeLocationParams = true) {
    const mergedParams = mergeLocationParams
      ? mergeLocationSearchParams(searchParams)
      : sanitizeSearchParams(searchParams);
    FacetFiltersForm.searchParamsPrev = mergedParams;

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;

    if (usesKitabooPublisherCollection() && !isLargeCollectionFacets()) {
      navigateWithFacetParams(mergedParams);
      return;
    }

    if (usesKitabooExclusionPagination()) {
      if (usesNativeFacetReload()) {
        navigateWithFacetParams(mergedParams);
        return;
      }

      if (updateURLHash) FacetFiltersForm.updateURLHash(mergedParams);

      if (collectionEl) collectionEl.classList.add('loading');
      if (countContainer) countContainer.classList.add('loading');
      if (countContainerDesktop) countContainerDesktop.classList.add('loading');

      const hasFilters = mergedParams && mergedParams.indexOf('filter.') !== -1;

      if (typeof window.__applyLargeCollectionExclusionFilters === 'function') {
        window.__applyLargeCollectionExclusionFilters(mergedParams);
        return;
      }

      if (typeof window.__renderLargeCollectionFilteredGrid === 'function') {
        const renderResult = window.__renderLargeCollectionFilteredGrid(mergedParams);
        Promise.resolve(renderResult).finally(() => {
          if (!hasFilters) {
            finishKitabooExclusionRefresh(refreshKitabooExclusionView());
          } else {
            clearKitabooCollectionLoading();
          }
        });
        return;
      }

      finishKitabooExclusionRefresh(refreshKitabooExclusionView());
      return;
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(mergedParams);

    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${mergedParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderActiveFacets(html);
        FacetFiltersForm.renderAdditionalElements(html);
        if (usesKitabooExclusionPagination()) {
          finishKitabooExclusionRefresh(refreshKitabooExclusionView());
          return;
        }
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (
          typeof window.__refreshLargeCollectionFilters === 'function' &&
          url.indexOf('filter.') === -1
        ) {
          window.__refreshLargeCollectionFilters();
        }
      })
      .catch(() => {
        clearKitabooCollectionLoading();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderActiveFacets(html);
    FacetFiltersForm.renderAdditionalElements(html);
    if (usesKitabooExclusionPagination()) {
      finishKitabooExclusionRefresh(refreshKitabooExclusionView());
      return;
    }
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    const cachedUrl = FacetFiltersForm.filterData.find(filterDataUrl).url;
    if (
      typeof window.__refreshLargeCollectionFilters === 'function' &&
      cachedUrl &&
      cachedUrl.indexOf('filter.') === -1
    ) {
      window.__refreshLargeCollectionFilters();
    }
    clearKitabooCollectionLoading();
  }

  static renderProductGridContainer(html) {
    const refreshResult = refreshKitabooExclusionView();
    if (refreshResult) {
      finishKitabooExclusionRefresh(refreshResult);
      return;
    }
    const container = document.getElementById('ProductGridContainer');
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (container && parsed) {
      container.innerHTML = parsed.innerHTML;
      document.dispatchEvent(new CustomEvent('product-grid:updated'));
    }
    clearKitabooCollectionLoading();
  }

  static renderProductCount(html) {
    const grid = document.getElementById('product-grid');
    const isFilteredHydration = grid && grid.dataset.kitabooHydrated === 'filtered';
    if (grid && grid.dataset.exclusionPagination === 'true' && !isFilteredHydration) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const parsedCount = parsed.getElementById('ProductCountDesktop') || parsed.getElementById('ProductCount');
    if (!parsedCount) return;
    updateAllProductCountElements(parsedCount.innerHTML);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && menuDrawer.bindEvents) menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target && event.target.dataset && event.target.dataset.lcFilter) return;
    const w = document.getElementById('FacetsWrapperDesktop');
    if (w && (w.dataset.largeCollection === 'true' || w.dataset.jsSidebarFilters === 'true')) {
      if (shouldReloadCollectionOnFacetChange()) {
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        const forms = [];
        sortFilterForms.forEach((form) => {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        });
        navigateWithFacetParams(mergeFacetFormParams(forms.filter(Boolean).join('&')));
        return;
      }
      if (typeof window.__lcFilterChange === 'function') window.__lcFilterChange();
      return;
    }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(mergeFacetFormParams(forms.filter(Boolean).join('&')), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const link = event.currentTarget;
    const isClearAll = link.classList.contains('active-facets__button-remove') ||
      link.classList.contains('mobile-facets__clear');

    if (isClearAll) {
      resetFacetFormInputs();
      FacetFiltersForm.filterData = [];
      if (isJsSidebarFiltersPage()) {
        window.location.assign(window.location.pathname);
        return;
      }
    }

    const params = parseFacetRemoveParams(link.href);
    FacetFiltersForm.renderPage(params, event, true, false);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

(function() {
  var wrapper = document.getElementById('FacetsWrapperDesktop');
  var mobileForm = document.getElementById('FacetFiltersFormMobile');
  var usesJsSidebarFilters = (wrapper && wrapper.dataset.jsSidebarFilters === 'true') ||
                             (mobileForm && mobileForm.dataset.jsSidebarFilters === 'true');
  if (!usesJsSidebarFilters) return;

  var isLargeCollection = (wrapper && wrapper.dataset.largeCollection === 'true') ||
                          (mobileForm && mobileForm.dataset.largeCollection === 'true');

  var collectionHandle = (wrapper && wrapper.dataset.collectionHandle) ||
                         (mobileForm && mobileForm.dataset.collectionHandle) || '';
  if (!collectionHandle) return;

  if (redirectIfInvalidCollectionUrlParams()) return;

  var collectionTitle = (wrapper && wrapper.dataset.collectionTitle) ||
                        (mobileForm && mobileForm.dataset.collectionTitle) || collectionHandle;

  var sectionId = '';
  var productGrid = document.getElementById('product-grid');
  if (productGrid) sectionId = productGrid.dataset.id || '';

  var searchUrls = [
    '/search?type=product&q=' + encodeURIComponent(collectionTitle) + '&options%5Bprefix%5D=last',
    '/search?type=product&q=' + encodeURIComponent(collectionTitle),
    '/search?type=product&q=' + encodeURIComponent('tag:' + collectionHandle),
    '/search?type=product&q=' + encodeURIComponent('vendor:' + collectionTitle)
  ];
  if (collectionHandle === 'all') {
    searchUrls = [
      '/search?type=product&q=' + encodeURIComponent('tag:all'),
      '/search?type=product&q=' + encodeURIComponent(collectionTitle) + '&options%5Bprefix%5D=last',
      '/search?type=product&q=*'
    ];
  }
  var searchUrlIndex = 0;

  function buildCollectionSectionFetchUrl(searchParams) {
    var params = new URLSearchParams(normalizeCollectionSearchParams(searchParams || ''));
    var target = new URLSearchParams();
    if (sectionId) target.set('section_id', sectionId);
    appendAllSearchParams(target, params);
    return window.location.pathname + '?' + target.toString();
  }

  function dedupeFilters(filters) {
    var merged = [];
    var listFilters = {};

    filters.forEach(function (filter) {
      if (filter.type === 'price_range') {
        merged.push(filter);
        return;
      }

      var key = filter.param_name || filter.label;
      if (!listFilters[key]) {
        listFilters[key] = {
          type: filter.type,
          label: filter.label,
          param_name: filter.param_name,
          values: [],
          valueKeys: {}
        };
        merged.push(listFilters[key]);
      }

      var bucket = listFilters[key];
      filter.values.forEach(function (val) {
        var valueKey = (val.param_name || bucket.param_name) + '::' + val.value;
        if (bucket.valueKeys[valueKey]) return;
        bucket.valueKeys[valueKey] = true;
        bucket.values.push(val);
      });
    });

    merged.forEach(function (filter) {
      delete filter.valueKeys;
    });
    return merged;
  }

  var activeFilters = {};
  var currentSearchParams = window.location.search.slice(1);

  function parseActiveFiltersFromURL() {
    activeFilters = {};
    var params = new URLSearchParams(window.location.search);
    params.forEach(function(value, key) {
      if (key.indexOf('filter.') === 0) {
        if (!activeFilters[key]) activeFilters[key] = [];
        activeFilters[key].push(value);
      }
    });
  }

  parseActiveFiltersFromURL();

  function buildDesktopFilterHTML(filters) {
    var html = '';
    var filterIndex = 0;

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      filterIndex++;
      var dataIndex = 'lcf-' + filterIndex;

      if (filter.type === 'list' || filter.type === 'boolean') {
        var activeCount = 0;
        var activeKey = filter.param_name;
        if (activeFilters[activeKey]) activeCount = activeFilters[activeKey].length;

        html += '<details class="facets__disclosure-vertical lc-filter" data-index="' + dataIndex + '" open>';
        html += '<summary class="facets__summary caption-large focus-offset">';
        html += '<div><span>' + escapeHtml(filter.label);
        if (activeCount > 0) html += '<span class="facets__selected no-js-hidden"> (' + activeCount + ')</span>';
        html += '</span>';
        html += '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
        html += '</div></summary>';

        html += '<div class="parent-display facets__display-vertical">';
        html += '<fieldset class="facets-wrap parent-wrap facets-wrap-vertical">';
        html += '<legend class="visually-hidden">' + escapeHtml(filter.label) + '</legend>';

        html += '<div class="facet-search-wrapper">';
        html += '<input type="text" class="facet-search" placeholder="Search..." onkeyup="filterFacetOptions(this)">';
        html += '<button type="button" class="facet-clear-btn" onclick="clearFacetSearch(this)" aria-label="Clear search">&times;</button>';
        html += '</div>';

        html += '<ul class="list-unstyled no-js-hidden" role="list">';
        for (var v = 0; v < filter.values.length; v++) {
          var val = filter.values[v];
          var isActive = activeFilters[activeKey] && activeFilters[activeKey].indexOf(val.value) !== -1;
          var isDisabled = val.count === 0 && !isActive && !filter.approximateCounts;
          var showMoreClass = (v >= 10) ? ' show-more-item hidden' : '';

          html += '<li class="list-menu__item facets__item' + showMoreClass + '">';
          html += '<label for="LCFilter-' + filterIndex + '-' + v + '" class="facet-checkbox' + (isDisabled ? ' facet-checkbox--disabled' : '') + '">';
          html += '<input type="checkbox" name="' + escapeHtml(val.param_name || activeKey) + '" value="' + escapeHtml(val.value) + '"';
          html += ' id="LCFilter-' + filterIndex + '-' + v + '"';
          if (isActive) html += ' checked';
          if (isDisabled) html += ' disabled';
          html += ' data-lc-filter="true">';

          html += '<svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">';
          html += '<rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>';
          html += '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">';
          html += '<path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          html += '<span aria-hidden="true">' + escapeHtml(val.label) + ' (' + val.count + (filter.approximateCounts ? '+' : '') + ')</span>';
          html += '<span class="visually-hidden">' + escapeHtml(val.label) + ' (' + val.count + (filter.approximateCounts ? '+' : '') + ')</span>';
          html += '</label></li>';
        }
        html += '</ul>';
        html += '<p class="SearchNoResult" style="display:none; color:red;"></p>';
        html += '</fieldset>';

        if (filter.values.length > 10) {
          html += '<show-more-button>';
          html += '<button class="button-show-more link underlined-link no-js-hidden" id="Show-More-lcf-' + filterIndex + '" type="button">';
          html += '<span class="label-show-more label-text"><span aria-hidden="true">+ </span>Show more</span>';
          html += '<span class="label-show-less label-text hidden"><span aria-hidden="true">- </span>Show less</span>';
          html += '</button>';
          html += '</show-more-button>';
        }

        html += '</div></details>';

      } else if (filter.type === 'price_range') {
        html += '<details class="facets__disclosure-vertical lc-filter" data-index="' + dataIndex + '" open>';
        html += '<summary class="facets__summary caption-large focus-offset">';
        html += '<div><span>' + escapeHtml(filter.label) + '</span>';
        html += '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
        html += '</div></summary>';

        html += '<div class="facets__display-vertical">';
        html += '<div class="facets__header-vertical">';
        html += '<span class="facets__selected">Max price: ' + formatMoney(filter.range_max) + '</span>';
        html += '</div>';
        html += '<price-range class="facets__price">';

        var minParamName = filter.min_value ? filter.min_value.param_name : (filter.param_name + '.gte');
        var maxParamName = filter.max_value ? filter.max_value.param_name : (filter.param_name + '.lte');
        var currentMin = '';
        var currentMax = '';
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(minParamName)) currentMin = urlParams.get(minParamName);
        if (urlParams.has(maxParamName)) currentMax = urlParams.get(maxParamName);

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(minParamName) + '" type="number" placeholder="0" min="0"';
        if (currentMin) html += ' value="' + escapeHtml(currentMin) + '"';
        html += ' max="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">From</label></div>';

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(maxParamName) + '" type="number" min="0"';
        if (currentMax) html += ' value="' + escapeHtml(currentMax) + '"';
        html += ' max="' + (filter.range_max / 100) + '" placeholder="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">To</label></div>';

        html += '</price-range>';
        html += '</div></details>';
      }
    }

    return html;
  }

  function buildMobileFilterHTML(filters) {
    var html = '';
    var filterIndex = 0;

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      filterIndex++;
      var dataIndex = 'mobile-lcf-' + filterIndex;

      if (filter.type === 'list' || filter.type === 'boolean') {
        var activeKey = filter.param_name;

        html += '<details class="mobile-facets__details lc-filter" data-index="' + dataIndex + '">';
        html += '<summary class="mobile-facets__summary focus-inset"><div>';
        html += '<span>' + escapeHtml(filter.label) + '</span>';
        html += '<span class="mobile-facets__arrow no-js-hidden"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></span>';
        html += '</div></summary>';

        html += '<div class="mobile-facets__submenu gradient">';
        html += '<button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">';
        html += '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg>';
        html += escapeHtml(filter.label);
        html += '</button>';

        html += '<ul class="mobile-facets__list list-unstyled" role="list">';
        for (var v = 0; v < filter.values.length; v++) {
          var val = filter.values[v];
          var isActive = activeFilters[activeKey] && activeFilters[activeKey].indexOf(val.value) !== -1;
          var isDisabled = val.count === 0 && !isActive && !filter.approximateCounts;

          html += '<li class="mobile-facets__item list-menu__item">';
          html += '<label for="LCFilterMobile-' + filterIndex + '-' + v + '" class="mobile-facets__label' + (isDisabled ? ' mobile-facets__label--disabled' : '') + '">';
          html += '<input class="mobile-facets__checkbox" type="checkbox" name="' + escapeHtml(val.param_name || activeKey) + '" value="' + escapeHtml(val.value) + '"';
          html += ' id="LCFilterMobile-' + filterIndex + '-' + v + '"';
          if (isActive) html += ' checked';
          if (isDisabled) html += ' disabled';
          html += ' data-lc-filter="true">';

          html += '<span class="mobile-facets__highlight"></span>';
          html += '<svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>';
          html += '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          html += '<span aria-hidden="true">' + escapeHtml(val.label) + ' (' + val.count + (filter.approximateCounts ? '+' : '') + ')</span>';
          html += '</label></li>';
        }
        html += '</ul>';

        html += '<div class="no-js-hidden mobile-facets__footer gradient">';
        html += '<button type="button" class="no-js-hidden button button--primary" onclick="this.closest(\'.mobile-facets__wrapper\').querySelector(\'summary\').click()">Apply</button>';
        html += '</div>';

        html += '</div></details>';

      } else if (filter.type === 'price_range') {
        html += '<details class="mobile-facets__details lc-filter" data-index="' + dataIndex + '">';
        html += '<summary class="mobile-facets__summary focus-inset"><div>';
        html += '<span>' + escapeHtml(filter.label) + '</span>';
        html += '<span class="mobile-facets__arrow no-js-hidden"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></span>';
        html += '</div></summary>';

        html += '<div class="mobile-facets__submenu gradient">';
        html += '<button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">';
        html += '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg>';
        html += escapeHtml(filter.label);
        html += '</button>';

        html += '<p class="mobile-facets__info">Max price: ' + formatMoney(filter.range_max) + '</p>';
        html += '<price-range class="facets__price">';

        var minPN = filter.min_value ? filter.min_value.param_name : (filter.param_name + '.gte');
        var maxPN = filter.max_value ? filter.max_value.param_name : (filter.param_name + '.lte');

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(minPN) + '" type="number" placeholder="0" min="0" inputmode="decimal" data-lc-filter="true">';
        html += '<label class="field__label">From</label></div>';
        html += '<div class="field"><input class="field__input" name="' + escapeHtml(maxPN) + '" type="number" min="0" inputmode="decimal" placeholder="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">To</label></div>';

        html += '</price-range>';

        html += '<div class="no-js-hidden mobile-facets__footer">';
        html += '<button type="button" class="no-js-hidden button button--primary" onclick="this.closest(\'.mobile-facets__wrapper\').querySelector(\'summary\').click()">Apply</button>';
        html += '</div>';

        html += '</div></details>';
      }
    }
    return html;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return cents;
    return (cents / 100).toFixed(2);
  }

  function collectFilterParams() {
    var params = new URLSearchParams();
    var sortSelect = document.querySelector('#SortBy') || document.querySelector('#KitabooSortBy');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    document.querySelectorAll('[data-lc-filter]').forEach(function(input) {
      if (input.type === 'checkbox') {
        if (input.checked && input.name && input.value) {
          params.append(input.name, input.value);
        }
      } else if (input.type === 'number') {
        if (input.value && input.name) {
          params.append(input.name, input.value);
        }
      }
    });

    return params.toString();
  }

  function updateFilteredProductCount(gridContainer, countContainer, countContainerDesktop, fallbackCount, countHtml) {
    if (countHtml && String(countHtml).trim()) {
      updateAllProductCountElements(countHtml);
      return;
    }

    var hasReadyCount = false;
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (el && el.dataset.countReady === 'true') hasReadyCount = true;
    });
    if (hasReadyCount) return;

    function applyCount(total) {
      var countText = total + ' product' + (total !== 1 ? 's' : '');
      updateAllProductCountElements(countText);
    }

    if (!gridContainer) {
      applyCount(fallbackCount || 0);
      return;
    }

    setTimeout(function () {
      var visible = gridContainer.querySelectorAll('#product-grid .grid__item').length;
      applyCount(visible || fallbackCount || 0);
    }, 80);
  }

  function renderLargeCollectionFilteredGrid(searchParams) {
    var gridContainer = document.getElementById('ProductGridContainer');
    var normalizedParams = normalizeCollectionSearchParams(searchParams);
    var hasFilters = normalizedParams && normalizedParams.indexOf('filter.') !== -1;
    var fetchUrl = buildCollectionSectionFetchUrl(normalizedParams);

    var collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
    if (collectionEl) collectionEl.classList.add('loading');
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (el) el.classList.add('loading');
    });

    return fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fetchedGrid = parsed.getElementById('ProductGridContainer');
        var productCount = 0;

        if (fetchedGrid && gridContainer) {
          gridContainer.innerHTML = fetchedGrid.innerHTML;
          if (window.KitabooExclusionPagination &&
              typeof window.KitabooExclusionPagination.resetCardTemplate === 'function') {
            window.KitabooExclusionPagination.resetCardTemplate();
          }
          var grid = gridContainer.querySelector('#product-grid');
          if (grid) {
            if (hasFilters) {
              grid.dataset.kitabooHydrated = 'filtered';
            } else {
              delete grid.dataset.kitabooHydrated;
            }
          }
          document.dispatchEvent(new CustomEvent('product-grid:updated'));
        }

        var countEl = parsed.getElementById('ProductCountDesktop') || parsed.getElementById('ProductCount');
        var countHtml = countEl ? countEl.innerHTML : '';
        var gridItems = parsed.querySelectorAll('#product-grid .grid__item');
        if (gridItems.length > 0) productCount = gridItems.length;
        if (countEl) {
          var countNum = (countEl.textContent || '').match(/(\d+)/);
          if (countNum) productCount = parseInt(countNum[1], 10);
        }

        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderActiveFacets(parsed);

        if (!document.querySelector('#ProductCount[data-count-ready="true"], #ProductCountDesktop[data-count-ready="true"]')) {
          updateFilteredProductCount(gridContainer, null, null, productCount, countHtml);
        }
        revealInitialCollectionCount();

        syncLargeCollectionSidebarFilters();
      })
      .catch(function () {
        clearKitabooCollectionLoading();
      })
      .finally(function () {
        clearKitabooCollectionLoading();
      });
  }

  function refreshLargeCollectionActiveFacets(searchParams) {
    var fetchUrl = buildCollectionSectionFetchUrl(searchParams);
    return fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        FacetFiltersForm.renderActiveFacets(parsed);
      })
      .catch(function () { /* keep existing active facets */ });
  }

  function applyLargeCollectionExclusionFilters(searchParams) {
    var normalizedParams = normalizeCollectionSearchParams(searchParams);
    var hasFilters = normalizedParams && normalizedParams.indexOf('filter.') !== -1;
    var grid = document.getElementById('product-grid');
    var gridContainer = document.getElementById('ProductGridContainer');
    var collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;

    if (collectionEl) collectionEl.classList.add('loading');
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (el) el.classList.add('loading');
    });

    if (!hasFilters) {
      if (
        window.KitabooExclusionPagination &&
        typeof window.KitabooExclusionPagination.rerenderFromBaseIndex === 'function' &&
        window.KitabooExclusionPagination.rerenderFromBaseIndex()
      ) {
        return Promise.resolve()
          .then(function () {
            parseActiveFiltersFromURL();
            if (typeof window.__syncActiveFacetPills === 'function') {
              window.__syncActiveFacetPills();
            }
            if (cachedCatalogFilters && cachedCatalogFilters.length) {
              renderFiltersToPlaceholders(cachedCatalogFilters);
            }
            return syncLargeCollectionSidebarFilters();
          })
          .finally(function () {
            clearKitabooCollectionLoading();
          });
      }

      if (window.KitabooExclusionPagination &&
          typeof window.KitabooExclusionPagination.resetFilteredView === 'function') {
        window.KitabooExclusionPagination.resetFilteredView();
      } else if (grid) {
        delete grid.dataset.kitabooHydrated;
      }

      return runLargeCollectionFilteredGrid(normalizedParams).then(function () {
        return finishKitabooExclusionRefresh(refreshKitabooExclusionView());
      }).then(function () {
        parseActiveFiltersFromURL();
        if (typeof window.__syncActiveFacetPills === 'function') {
          window.__syncActiveFacetPills();
        }
        return syncLargeCollectionSidebarFilters();
      });
    }

    if (grid) grid.dataset.kitabooHydrated = 'filtered';

    if (isLargeCollectionFacets()) {
      var applyPromise = window.KitabooExclusionPagination &&
        typeof window.KitabooExclusionPagination.applyFacetFilters === 'function'
        ? window.KitabooExclusionPagination.applyFacetFilters()
        : renderLargeCollectionFilteredGrid(normalizedParams);

      return Promise.resolve(applyPromise)
        .then(function () {
          parseActiveFiltersFromURL();
          if (typeof window.__syncActiveFacetPills === 'function') {
            window.__syncActiveFacetPills();
          }
          return syncLargeCollectionSidebarFilters();
        })
        .finally(function () {
          clearKitabooCollectionLoading();
        });
    }

    return renderLargeCollectionFilteredGrid(normalizedParams)
      .then(function () {
        parseActiveFiltersFromURL();
        if (typeof window.__syncActiveFacetPills === 'function') {
          window.__syncActiveFacetPills();
        }
        return syncLargeCollectionSidebarFilters();
      })
      .finally(function () {
        clearKitabooCollectionLoading();
      });
  }

  function scheduleFilteredIndexWarmup() {
    if (!window.KitabooExclusionPagination ||
        typeof window.KitabooExclusionPagination.warmFilteredIndex !== 'function') {
      return;
    }

    setTimeout(function () {
      window.KitabooExclusionPagination.warmFilteredIndex();
    }, 150);
  }

  function runLargeCollectionFilteredGrid(searchParams) {
    if (usesKitabooExclusionPagination()) {
      var hasFilters = searchParams && searchParams.indexOf('filter.') !== -1;
      if (hasFilters && isLargeCollectionFacets()) {
        return applyLargeCollectionExclusionFilters(searchParams);
      }
    }

    return renderLargeCollectionFilteredGrid(searchParams).then(function () {
      var hasFilters = searchParams && searchParams.indexOf('filter.') !== -1;
      if (!hasFilters) return;

      var grid = document.getElementById('product-grid');
      var itemCount = grid ? grid.querySelectorAll('.grid__item').length : 0;
      if (itemCount > 0) return;

      if (window.KitabooExclusionPagination && typeof window.KitabooExclusionPagination.applyFacetFilters === 'function') {
        return window.KitabooExclusionPagination.applyFacetFilters();
      }
    });
  }

  window.__renderLargeCollectionFilteredGrid = function (searchParams) {
    return runLargeCollectionFilteredGrid(searchParams);
  };

  window.__applyLargeCollectionExclusionFilters = function (searchParams) {
    return applyLargeCollectionExclusionFilters(searchParams);
  };

  window.__refreshLargeCollectionFilters = refreshSearchFilters;
  window.__syncLargeCollectionSidebarFilters = syncLargeCollectionSidebarFilters;
  window.__refreshExclusionCollectionFacetUi = refreshExclusionCollectionFacetUi;

  function handleLCFilterChange() {
    var searchParams = normalizeCollectionSearchParams(mergeFacetFormParams(collectFilterParams()));

    if (shouldReloadCollectionOnFacetChange() || usesNativeFacetReload()) {
      navigateWithFacetParams(searchParams);
      return;
    }

    history.pushState(
      { searchParams: searchParams },
      '',
      window.location.pathname + (searchParams ? '?' + searchParams : '')
    );
    parseActiveFiltersFromURL();

    var hasFilters = searchParams && searchParams.indexOf('filter.') !== -1;

    if (usesKitabooExclusionPagination()) {
      applyLargeCollectionExclusionFilters(searchParams);
      return;
    }

    runLargeCollectionFilteredGrid(searchParams);
  }

  var lcDebounceTimer = null;
  function debouncedLCFilterChange() {
    if (lcDebounceTimer) clearTimeout(lcDebounceTimer);
    lcDebounceTimer = setTimeout(function() {
      lcDebounceTimer = null;
      handleLCFilterChange();
    }, 500);
  }
  window.__lcFilterChange = debouncedLCFilterChange;

  function bindFilterEvents() {
    document.querySelectorAll('[data-lc-filter]').forEach(function(input) {
      if (input.__lcBound) return;
      input.__lcBound = true;

      if (input.type === 'checkbox') {
        input.addEventListener('change', function(e) {
          e.stopPropagation();
          debouncedLCFilterChange();
        });
      } else if (input.type === 'number') {
        input.addEventListener('change', function(e) {
          e.stopPropagation();
          debouncedLCFilterChange();
        });
      }
    });
  }

  function parseSearchFilters(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var filters = [];
    var filterRoot = parsed.getElementById('FacetsWrapperDesktop') || parsed;
    var filterElements = filterRoot.querySelectorAll('.facets__disclosure-vertical, .facets__disclosure');

    filterElements.forEach(function(el) {
      var summarySpan = el.querySelector('summary span');
      if (!summarySpan) return;

      var label = summarySpan.textContent.trim().replace(/\s*\(\d+\)$/, '');

      var priceRange = el.querySelector('price-range');
      if (priceRange) {
        var minInput = priceRange.querySelector('input[name*=".gte"], input[name*="price_min"]');
        var maxInput = priceRange.querySelector('input[name*=".lte"], input[name*="price_max"]');
        var rangeMax = 0;
        if (maxInput) {
          var maxAttr = maxInput.getAttribute('max') || maxInput.getAttribute('placeholder') || '0';
          rangeMax = parseFloat(maxAttr) * 100;
        }
        filters.push({
          type: 'price_range',
          label: label,
          param_name: 'filter.v.price',
          range_max: rangeMax,
          min_value: { param_name: minInput ? minInput.name : 'filter.v.price.gte' },
          max_value: { param_name: maxInput ? maxInput.name : 'filter.v.price.lte' }
        });
        return;
      }

      var listRoot = el.querySelector('ul.no-js-hidden') ||
        el.querySelector('ul.mobile-facets__list') ||
        el.querySelector('ul.list-unstyled');
      if (!listRoot) return;

      var checkboxes = listRoot.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length === 0) return;

      var paramName = checkboxes[0].name || '';
      var values = [];
      var seenValues = {};

      checkboxes.forEach(function(cb) {
        var valueKey = (cb.name || paramName) + '::' + cb.value;
        if (seenValues[valueKey]) return;
        seenValues[valueKey] = true;

        var li = cb.closest('li');
        var spanEl = li ? li.querySelector('span[aria-hidden="true"]') : null;
        var labelText = '';
        var count = 0;

        if (spanEl) {
          var rawText = spanEl.textContent.trim();
          var countMatch = rawText.match(/\((\d+)\)\s*$/);
          if (countMatch) {
            count = parseInt(countMatch[1], 10);
            labelText = rawText.replace(/\s*\(\d+\)\s*$/, '');
          } else {
            labelText = rawText;
          }
        }

        values.push({
          value: cb.value,
          label: labelText || cb.value,
          count: count,
          param_name: cb.name || paramName,
          active: cb.checked
        });
      });

      filters.push({
        type: 'list',
        label: label,
        param_name: paramName,
        values: values
      });
    });

    return dedupeFilters(filters);
  }

  var cachedCatalogFilters = null;
  var backgroundFilterRefreshTimer = null;
  var lastBackgroundFilterRefreshAt = 0;

  function scheduleBackgroundFilterCountRefresh() {
    if (backgroundFilterRefreshTimer) clearTimeout(backgroundFilterRefreshTimer);
    backgroundFilterRefreshTimer = setTimeout(function () {
      backgroundFilterRefreshTimer = null;
      refreshIndexFilterCountsInBackground();
    }, 400);
  }

  function filtersAreStillLoading() {
    var desktopPlaceholder = document.getElementById('LargeCollectionFiltersPlaceholder');
    var mobilePlaceholder = document.getElementById('LargeCollectionMobileFiltersPlaceholder');
    return !!(
      (desktopPlaceholder && desktopPlaceholder.classList.contains('large-collection-filters-loading')) ||
      (mobilePlaceholder && mobilePlaceholder.classList.contains('large-collection-filters-loading'))
    );
  }

  function loadLargeCollectionFiltersFast() {
    var instantNative = parseNativeFiltersFromDocument(document);
    if (instantNative && instantNative.length > 0) {
      renderFiltersToPlaceholders(instantNative);
      cachedCatalogFilters = instantNative;
      scheduleBackgroundFilterCountRefresh();
      return Promise.resolve(instantNative);
    }

    return fetchSearchFiltersHtml(false)
      .then(function (filters) {
        if (!filters || !filters.length) {
          throw new Error('No search filters available');
        }
        cachedCatalogFilters = filters;
        return renderMergedFilters(filters);
      })
      .catch(function () {
        return fetchCollectionNativeFilters(false)
          .then(function (filters) {
            if (!filters || !filters.length) {
              throw new Error('No native collection filters found');
            }
            cachedCatalogFilters = filters;
            return renderMergedFilters(filters);
          });
      })
      .then(function () {
        scheduleBackgroundFilterCountRefresh();
      })
      .catch(function () {
        showFilterLoadError();
        scheduleBackgroundFilterCountRefresh();
      });
  }

  function refreshIndexFilterCountsInBackground() {
    var nativeFilters = parseNativeFiltersFromDocument(document) || cachedCatalogFilters;
    if (!nativeFilters || !nativeFilters.length) return;

    var now = Date.now();
    if (now - lastBackgroundFilterRefreshAt < 800) return;
    lastBackgroundFilterRefreshAt = now;

    if (filtersAreStillLoading()) {
      renderFiltersToPlaceholders(nativeFilters);
    }

    var catalogOptions = { lightIndex: true };
    if (hasActiveFiltersInURL() && usesKitabooExclusionPagination()) {
      catalogOptions.scopedCounts = true;
    }

    fetchIndexCatalogFilters(catalogOptions, nativeFilters)
      .then(function (filters) {
        if (!filters || !filters.length) return;
        cachedCatalogFilters = filters;
        if (hasActiveFiltersInURL() && !usesKitabooExclusionPagination()) {
          return fetchFilteredCountFilters(filters).then(function (mergedFilters) {
            renderFiltersToPlaceholders(mergedFilters);
          });
        }
        renderFiltersToPlaceholders(filters);
      })
      .catch(function () {});
  }

  function hasActiveFiltersInURL() {
    var params = new URLSearchParams(window.location.search);
    var found = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && value) found = true;
    });
    return found;
  }

  function mergeFilterCounts(catalogFilters, countFilters) {
    var countMaps = {};

    countFilters.forEach(function (filter) {
      if (!filter.param_name) return;
      countMaps[filter.param_name] = countMaps[filter.param_name] || {};
      filter.values.forEach(function (val) {
        countMaps[filter.param_name][val.value] = val.count;
      });
    });

    return catalogFilters.map(function (filter) {
      if (filter.type === 'price_range') return filter;

      var map = countMaps[filter.param_name] || {};
      var values = filter.values.map(function (val) {
        if (map[val.value] == null) return val;
        return {
          value: val.value,
          label: val.label,
          count: map[val.value],
          param_name: val.param_name,
          active: val.active
        };
      });

      return {
        type: filter.type,
        label: filter.label,
        param_name: filter.param_name,
        values: values
      };
    });
  }

  function parseNativeFiltersFromDocument(doc) {
    var root = doc || document;
    var jsonEl = root.getElementById('LargeCollectionNativeFiltersJson');
    if (!jsonEl || !jsonEl.textContent) return null;

    try {
      var parsed = JSON.parse(jsonEl.textContent);
      if (!Array.isArray(parsed) || parsed.length === 0) return null;
      return dedupeFilters(parsed);
    } catch (error) {
      return null;
    }
  }

  function fetchCollectionNativeFilters(withFilterParams) {
    function buildFetchUrl(includeSectionId) {
      var params = new URLSearchParams();
      if (includeSectionId && sectionId) params.set('section_id', sectionId);

      if (withFilterParams) {
        var urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach(function (value, key) {
          if (key.indexOf('filter.') === 0 && value) {
            params.append(key, value);
          }
        });
        if (!params.has('sort_by') && urlParams.has('sort_by')) {
          params.set('sort_by', urlParams.get('sort_by'));
        }
      }

      return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    }

    function requestFilters(fetchUrl) {
      return fetch(fetchUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var filters = parseNativeFiltersFromDocument(parsed);
          if (filters && filters.length > 0) return filters;
          throw new Error('No native collection filters found');
        });
    }

    return requestFilters(buildFetchUrl(true)).catch(function () {
      return Promise.reject(new Error('No native collection filters found'));
    });
  }

  function normalizeFilterValueKey(value) {
    return String(value || '').toLowerCase().trim();
  }

  var LC_FILTER_ORDER = [
    'filter.v.price',
    'filter.p.product_type',
    'filter.p.m.custom.combined_product_tags',
    'filter.p.m.custom.author',
    'filter.p.vendor',
    'filter.p.m.custom.book_type'
  ];

  function getFilterSortIndex(paramName) {
    var index = LC_FILTER_ORDER.indexOf(paramName);
    return index === -1 ? LC_FILTER_ORDER.length + 1 : index;
  }

  function mergeCatalogFilterSources(nativeFilters, indexFilters) {
    var mergedByParam = Object.create(null);
    var priceFilters = [];

    function ingestFilter(filter) {
      if (!filter) return;
      if (filter.type === 'price_range') {
        priceFilters.push(filter);
        return;
      }
      if (!filter.param_name || !Array.isArray(filter.values)) return;

      if (!mergedByParam[filter.param_name]) {
        mergedByParam[filter.param_name] = {
          type: filter.type || 'list',
          label: filter.label,
          param_name: filter.param_name,
          approximateCounts: !!filter.approximateCounts,
          valueMap: Object.create(null)
        };
      }

      var bucket = mergedByParam[filter.param_name];
      if (filter.label) bucket.label = filter.label;
      if (filter.approximateCounts) bucket.approximateCounts = true;

      filter.values.forEach(function (val) {
        var key = normalizeFilterValueKey(val.value);
        if (!key) return;
        var existing = bucket.valueMap[key];
        if (!existing || (val.count || 0) > (existing.count || 0)) {
          bucket.valueMap[key] = {
            value: val.value,
            label: val.label || val.value,
            count: val.count || 0,
            param_name: val.param_name || filter.param_name,
            active: !!val.active
          };
        }
      });
    }

    (indexFilters || []).forEach(ingestFilter);
    (nativeFilters || []).forEach(ingestFilter);

    var filters = priceFilters.slice();
    Object.keys(mergedByParam)
      .sort(function (a, b) {
        return getFilterSortIndex(a) - getFilterSortIndex(b);
      })
      .forEach(function (paramName) {
        var bucket = mergedByParam[paramName];
        var values = Object.keys(bucket.valueMap).map(function (key) {
          return bucket.valueMap[key];
        }).sort(function (a, b) {
          return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
        });
        if (values.length === 0) return;
        filters.push({
          type: bucket.type,
          label: bucket.label,
          param_name: paramName,
          values: values,
          approximateCounts: bucket.approximateCounts
        });
      });

    return filters;
  }

  function fetchIndexCatalogFilters(options, nativeFilters) {
    if (!window.KitabooExclusionPagination ||
        typeof window.KitabooExclusionPagination.ensureBaseIndexForFacetCounts !== 'function' ||
        typeof window.KitabooExclusionPagination.buildLargeCollectionFilterCatalog !== 'function') {
      return Promise.resolve(null);
    }

    var catalogOptions = Object.assign({}, options || {});
    if (nativeFilters && nativeFilters.length) {
      catalogOptions.nativeFilters = nativeFilters;
    }

    return window.KitabooExclusionPagination.ensureBaseIndexForFacetCounts(null, catalogOptions)
      .then(function () {
        return window.KitabooExclusionPagination.buildLargeCollectionFilterCatalog(catalogOptions);
      })
      .catch(function () {
        return null;
      });
  }

  function fetchNativeCatalogFilters() {
    var domFilters = parseNativeFiltersFromDocument(document);
    if (domFilters && domFilters.length > 0) {
      return Promise.resolve(domFilters);
    }

    return fetchSearchFiltersHtml(false).catch(function () {
      return fetchCollectionNativeFilters(false);
    });
  }

  function fetchCatalogFilters(options) {
    var opts = options || {};
    var instantNative = parseNativeFiltersFromDocument(document);
    if (
      instantNative &&
      instantNative.length > 0 &&
      !opts.scopedCounts &&
      !hasActiveFiltersInURL()
    ) {
      return Promise.resolve(instantNative);
    }

    return fetchNativeCatalogFilters().then(function (nativeFilters) {
      if (opts.nativeOnly && nativeFilters && nativeFilters.length > 0) {
        return nativeFilters;
      }

      return fetchIndexCatalogFilters(opts, nativeFilters).then(function (indexFilters) {
        var merged = mergeCatalogFilterSources(nativeFilters || [], indexFilters || []);
        if (merged.length > 0) return merged;
        if (nativeFilters && nativeFilters.length > 0) return nativeFilters;
        throw new Error('No filters available');
      });
    });
  }

  function fetchFilteredCountFilters(catalogFilters) {
    var nativeFilters = (catalogFilters || []).filter(function (filter) {
      return filter && filter.type !== 'price_range';
    });

    return fetchIndexCatalogFilters({ scopedCounts: true }, nativeFilters)
      .then(function (indexFilters) {
        if (indexFilters && indexFilters.length > 0) {
          return mergeCatalogFilterSources(catalogFilters, indexFilters);
        }
        return fetchCollectionNativeFilters(true)
          .catch(function () {
            if (!window.__excludePublishers) {
              return fetchSearchFiltersHtml(true);
            }
            throw new Error('Filtered native filters unavailable');
          });
      });
  }

  function scoreParsedFilters(filters) {
    if (!filters || !filters.length) return 0;
    return filters.reduce(function (sum, filter) {
      if (filter.type === 'price_range') return sum + 1;
      return sum + ((filter.values && filter.values.length) || 0);
    }, 0);
  }

  function fetchSearchFiltersHtml(withFilterParams) {
    var filterParams = '';
    if (withFilterParams) {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0) {
          filterParams += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }
      });
    }

    var requests = searchUrls.map(function (baseUrl, startIdx) {
      var joiner = baseUrl.indexOf('?') === -1 ? '?' : '&';
      var url = baseUrl + (filterParams ? joiner + filterParams.replace(/^&/, '') : '');

      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var filters = parseSearchFilters(html);
          return {
            startIdx: startIdx,
            filters: filters,
            score: scoreParsedFilters(filters)
          };
        })
        .catch(function () {
          return { startIdx: startIdx, filters: [], score: 0 };
        });
    });

    return Promise.all(requests).then(function (results) {
      results.sort(function (a, b) {
        return b.score - a.score;
      });
      var best = results[0];
      if (!best || best.score <= 0) {
        return Promise.reject(new Error('No search filters available'));
      }
      searchUrlIndex = best.startIdx;
      return best.filters;
    });
  }

  function renderMergedFilters(catalogFilters) {
    if (hasActiveFiltersInURL()) {
      return fetchFilteredCountFilters(catalogFilters)
        .then(function (mergedFilters) {
          renderFiltersToPlaceholders(mergedFilters);
        })
        .catch(function () {
          renderFiltersToPlaceholders(catalogFilters);
        });
    }

    renderFiltersToPlaceholders(catalogFilters);
    return Promise.resolve();
  }

  function syncLargeCollectionSidebarFilters() {
    parseActiveFiltersFromURL();
    var instantNative = parseNativeFiltersFromDocument(document);
    var hasFilters = hasActiveFiltersInURL();

    if (instantNative && instantNative.length > 0) {
      renderFiltersToPlaceholders(instantNative);
      cachedCatalogFilters = instantNative;
    } else if (!cachedCatalogFilters || !cachedCatalogFilters.length) {
      return loadLargeCollectionFiltersFast();
    }

    if (hasFilters) {
      if (usesKitabooExclusionPagination()) {
        return fetchIndexCatalogFilters({ scopedCounts: true }, cachedCatalogFilters)
          .then(function (filters) {
            if (filters && filters.length > 0) {
              cachedCatalogFilters = filters;
              renderFiltersToPlaceholders(filters);
            }
          })
          .catch(function () {
            scheduleBackgroundFilterCountRefresh();
          });
      }

      return fetchCollectionNativeFilters(true)
        .then(function (filters) {
          if (filters && filters.length > 0) {
            cachedCatalogFilters = filters;
            return renderMergedFilters(filters);
          }
        })
        .catch(function () {
          scheduleBackgroundFilterCountRefresh();
        });
    }

    scheduleBackgroundFilterCountRefresh();
    return Promise.resolve();
  }

  function refreshSearchFilters() {
    cachedCatalogFilters = null;
    return syncLargeCollectionSidebarFilters();
  }

  function showFilterLoadError() {
    var desktopPlaceholder = document.getElementById('LargeCollectionFiltersPlaceholder');
    if (desktopPlaceholder) {
      desktopPlaceholder.classList.remove('large-collection-filters-loading');
      desktopPlaceholder.innerHTML = '<p style="padding:10px 0;color:#666;font-size:1.3rem;">Filters could not be loaded for this collection.</p>';
    }
    var mobilePlaceholder = document.getElementById('LargeCollectionMobileFiltersPlaceholder');
    if (mobilePlaceholder) {
      mobilePlaceholder.classList.remove('large-collection-filters-loading');
      mobilePlaceholder.innerHTML = '<p style="padding:10px 0;color:#666;font-size:1.3rem;">Filters could not be loaded.</p>';
    }
  }

  function renderFiltersToPlaceholders(filters) {
    var totalValues = 0;
    (filters || []).forEach(function (filter) {
      if (filter && Array.isArray(filter.values)) {
        totalValues += filter.values.length;
      }
    });

    var renderNow = function () {
      var desktopPlaceholder = document.getElementById('LargeCollectionFiltersPlaceholder');
      if (desktopPlaceholder) {
        var desktopHTML = buildDesktopFilterHTML(filters);
        desktopPlaceholder.innerHTML = desktopHTML;
        desktopPlaceholder.classList.remove('large-collection-filters-loading');

        if (!document.querySelector('#verticalTitle')) {
          var heading = document.createElement('h2');
          heading.className = 'facets__heading facets__heading--vertical caption-large text-body';
          heading.id = 'verticalTitle';
          heading.tabIndex = -1;
          heading.textContent = 'Filter:';
          desktopPlaceholder.insertBefore(heading, desktopPlaceholder.firstChild);
        }
      }

      var mobilePlaceholder = document.getElementById('LargeCollectionMobileFiltersPlaceholder');
      if (mobilePlaceholder) {
        var mobileHTML = buildMobileFilterHTML(filters);
        mobilePlaceholder.innerHTML = mobileHTML;
        mobilePlaceholder.classList.remove('large-collection-filters-loading');
      }

      bindFilterEvents();

      if (typeof bindFacetInputs === 'function') {
        try { bindFacetInputs(); } catch(e) {}
      }

      if (typeof window.__syncActiveFacetPills === 'function') {
        window.__syncActiveFacetPills();
      }

      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('lc-filters:rendered'));
      }, 100);
    };

    if (totalValues > 200) {
      window.setTimeout(renderNow, 0);
      return;
    }

    renderNow();
  }

  window.addEventListener('popstate', function(event) {
    if (!usesJsSidebarFilters || shouldReloadCollectionOnFacetChange()) return;
    parseActiveFiltersFromURL();

    var popSearchParams = normalizeCollectionSearchParams(window.location.search.slice(1));
    runLargeCollectionFilteredGrid(popSearchParams).then(function () {
      if (usesKitabooExclusionPagination() && popSearchParams.indexOf('filter.') === -1) {
        finishKitabooExclusionRefresh(refreshKitabooExclusionView());
      }
    });
  });

  document.addEventListener('kitaboo:visible-index-updated', function (event) {
    if (!event || !event.detail) return;
    if (!Array.isArray(event.detail.products) || !event.detail.products.length) return;
    scheduleBackgroundFilterCountRefresh();
  });

  var initialParams = normalizeCollectionSearchParams(window.location.search.slice(1));
  loadLargeCollectionFiltersFast();
  if (initialParams.indexOf('filter.') !== -1) {
    if (usesKitabooExclusionPagination() && isLargeCollectionFacets()) {
      // epub/ebook: collection-publisher-pagination applyFacetFilters on DOMContentLoaded
    } else if (usesKitabooExclusionPagination()) {
      renderLargeCollectionFilteredGrid(initialParams);
    } else {
      runLargeCollectionFilteredGrid(initialParams);
    }
  }
})();
































